import parsePhoneNumber from "libphonenumber-js";
import moment from "moment";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs-plugin-utc";

dayjs.extend(dayjsPluginUTC);

export const validateEmail = (email) => {
  return email?.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
    ? true
    : false;
};
export const validateLastFour = (ssn) => {
  return ssn?.match(/^[0-9]{4}$/) ? true : false;
};
export const validateName = (name) => {
  return name?.match(/^(?=.{1,40}$)[a-zA-Z]+(?:[-' ][a-zA-Z]+)*$/)
    ? true
    : false;
};
export const validateZipCode = (zip) => {
  return zip?.match(/(^\d{5}$)|(^\d{5}-\d{4}$)/) ? true : false;
};
export const validateState = (state) => {
  return state?.match(
    /(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])/
  )
    ? true
    : false;
};
export const validateAddress = (address) => {
  return address?.match(/^[a-zA-Z0-9\s.#,'-]*$/) && address?.length > 0
    ? true
    : false;
};
export const validateString = (name) => {
  return name && name?.length > 0 ? true : false;
};

export const hasStarted = (field) => {
  if (field !== undefined && field !== null) {
    return 1;
  }
  return 0;
};

// Helper function to convert HEX to RGBA
export const hexToRgba = (hex, alpha = 1) => {
  // Remove the hash if it exists
  hex = hex.replace("#", "");

  // Parse the hex values
  let r, g, b;
  if (hex.length === 3) {
    // Short notation (e.g. #FFF)
    r = parseInt(hex.charAt(0) + hex.charAt(0), 16);
    g = parseInt(hex.charAt(1) + hex.charAt(1), 16);
    b = parseInt(hex.charAt(2) + hex.charAt(2), 16);
  } else {
    // Full notation (e.g. #FFFFFF)
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  // Return the rgba value
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const validatePhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString) return false;
  const phoneNumber = parsePhoneNumber(phoneNumberString, "US");
  if (phoneNumber && phoneNumber.isValid()) {
    return true;
  } else {
    return false;
  }
};
export const validateSocial = (ssn) => {
  return ssn?.match(/^\d{3}-?\d{2}-?\d{4}$/) ? true : false;
};
export const numberWithCommas = (x) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
};
export const formatBytes = (a) => {
  if (0 === a) return "0 Bytes";
  var c = 1024,
    d = 0,
    e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
};

export const FormatPhone = (nput) => {
  let newValue = "";
  if (nput[0] === "+" && nput[1] === "1") nput = nput.replace("+1", "");
  const input = nput.replace(/\D/g, "").substring(0, 10);
  const zip = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);

  if (input.length > 6) {
    newValue = `${zip}-${middle}-${last}`;
  } else if (input.length === 6) {
    newValue = `${zip}-${middle}`;
  } else if (input.length > 3) {
    newValue = `${zip}-${middle}`;
  } else if (input.length === 3) {
    newValue = `${zip}`;
  } else if (input.length > 0) {
    newValue = `${zip}`;
  }
  return newValue;
};

export const FormatEXT = (value) => {
  // Remove all non-digit characters
  const digits = (value || "").replace(/\D/g, "");
  // Extract parts based on digit count
  const matches = digits.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d*)$/);
  let formattedNumber = "";

  if (matches) {
    const [, area, firstThree, lastFour, ext] = matches;
    // Build formatted number
    if (area) formattedNumber += `${area}`;
    if (firstThree) formattedNumber += `-${firstThree}`;
    if (lastFour) formattedNumber += `-${lastFour}`;
    if (ext) formattedNumber += ` ext ${ext}`;
  }

  return formattedNumber;
};

export const NumbersOnly = (input) => {
  return (input || "").replace(/\D/g, "");
};

export const formatExpiration = (value) => {
  // Remove all non-digit characters
  value = value.replace(/\D/g, "");

  // Add a "/" after the second digit
  if (value.length > 2) {
    value = value.slice(0, 2) + "/" + value.slice(2, 4);
  }

  // Limit output to MM/YY format
  return value.slice(0, 5);
};

export const isExpirationValid = (mmYY) => {
  // Split input into MM and YY
  const [month, year] = mmYY.split("/").map(Number);

  // Validate format
  if (!month || !year || month < 1 || month > 12 || String(year).length !== 2) {
    return false; // Invalid format
  }

  // Get current month and year
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // Months are zero-based
  const currentYear = now.getFullYear() % 100; // Get last two digits of year

  // Check expiration
  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return false; // Expired
  }

  return true; // Not expired
};

export const FormatSSN = (nput, isInput) => {
  let actualInput = nput || "";
  if (actualInput?.length <= 0 && !isInput) return <i>n/a</i>;
  if (actualInput?.length <= 0 && isInput) return "";
  let newValue = "";
  if (actualInput[0] === "+" && actualInput[1] === "1")
    actualInput = actualInput.replace("+1", "");
  const input = actualInput.replace(/\D/g, "").substring(0, 10);
  const zip = input.substring(0, 3);
  const middle = input.substring(3, 5);
  const last = input.substring(5, 9);

  if (input.length > 5) {
    newValue = `${zip}-${middle}-${last}`;
  } else if (input.length === 5) {
    newValue = `${zip}-${middle}`;
  } else if (input.length > 3) {
    newValue = `${zip}-${middle}`;
  } else if (input.length === 3) {
    newValue = `${zip}`;
  } else if (input.length > 0) {
    newValue = `${zip}`;
  }
  return newValue;
};

export const FormatDate = (nput) => {
  let actualInput = nput || "";
  if (actualInput?.length <= 0) return <i>n/a</i>;
  let newValue = "";
  if (actualInput[0] === "+" && actualInput[1] === "1")
    actualInput = actualInput.replace("+1", "");
  const input = actualInput.replace(/\D/g, "").substring(0, 10);
  const zip = input.substring(0, 2);
  const middle = input.substring(2, 4);
  const last = input.substring(4, 8);

  if (input.length > 5) {
    newValue = `${zip}/${middle}/${last}`;
  } else if (input.length === 5) {
    newValue = `${zip}/${middle}`;
  } else if (input.length > 3) {
    newValue = `${zip}/${middle}`;
  } else if (input.length === 3) {
    newValue = `${zip}`;
  } else if (input.length > 0) {
    newValue = `${zip}`;
  }
  return newValue;
};

export const formatMoney = (amount) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    amount || 0
  );

export const flatMoney = (amount) => {
  const val = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount || 0);
  return val.split(".")[0];
};

export const formatPercent = (val, points) => {
  return (val || 0).toFixed(points || 0) + "%";
};

export const prettyPhone = (phoneNumberString) => {
  if (!phoneNumberString) return <i>n/a</i>;
  const phoneNumber = parsePhoneNumber(phoneNumberString, "US");
  if (phoneNumber && phoneNumber.country === "US") {
    return phoneNumber.formatNational();
  } else if (phoneNumber) {
    return phoneNumber.formatInternational();
  } else {
    return phoneNumberString;
  }
};

export const plainPhone = (phoneNumberString) => {
  if (!phoneNumberString) return <i>n/a</i>;
  const newPhone = prettyPhone(phoneNumberString);
  return newPhone?.replace("(", "").replace(") ", "-") || phoneNumberString;
};

function stripCSS(htmlString) {
  return htmlString.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "");
}

export const stripHTML = (html) => {
  let newHTML = stripCSS(html || "");
  const div = document.createElement("div");
  div.innerHTML = newHTML;
  const text = div.textContent || div.innerText || "";
  return text;
};

export const stringifyValues = (data) => {
  // Base case: if data is a primitive value, return it as a string
  if (typeof data !== "object" || data === null) {
    return stripHTML(String(data));
  }

  // Handle arrays: recursively stringify each element
  if (Array.isArray(data)) {
    return stripHTML(data.map(stringifyValues).join(" "));
  }

  // Handle objects: recursively stringify each value
  return stripHTML(Object.values(data).map(stringifyValues).join(" "));
};

export const delay = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const capitalize = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const flatten = (data) => {
  const newObject = {};
  Object.keys(data).forEach((key) => {
    const tempObject = data[key];
    Object.keys(tempObject).forEach((field) => {
      newObject[field] = tempObject[field];
    });
  });
  return newObject;
};

export const parseAddress = (components) => {
  const now = {};
  components.forEach((c) => {
    now[c.types[0]] = {
      long: c.long_name,
      short: c.short_name,
    };
  });
  return now;
};

export const timeout = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const validateAccountNumber = (accountNumber) => {
  // Remove all non-digit characters (if any)
  let cleaned = (accountNumber || "").replace(/\D/g, "");

  // Check the length is between 4 and 17 digits
  if (cleaned.length >= 6 && cleaned.length <= 16) {
    return true;
  } else {
    return false;
  }
};

export const viewDocument = (pdfUrl) => {
  var link = document.createElement("a");
  link.href = pdfUrl;
  link.target = "_blank";
  link.click();
};

export const validateRoutingNumber = (routingNumber) => {
  // Remove all non-digit characters (if any)
  let cleaned = (routingNumber || "").replace(/\D/g, "");

  // Check if the length is exactly 9 digits
  if (cleaned.length !== 9) {
    return false;
  }

  // Convert the string to an array of integers
  let digits = cleaned.split("").map(Number);

  // Apply the checksum formula
  let checksum =
    3 * (digits[0] + digits[3] + digits[6]) +
    7 * (digits[1] + digits[4] + digits[7]) +
    1 * (digits[2] + digits[5] + digits[8]);

  // Validate the checksum
  return checksum % 10 === 0;
};

export const flattenObject = (obj, parentKey = "", result = {}) => {
  for (const [key, value] of Object.entries(obj)) {
    const newKey = parentKey ? `${parentKey}.${key}` : key;

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      flattenObject(value, newKey, result);
    } else {
      result[newKey] = value;
    }
  }
  return result;
};

export const containsHTML = (str) => {
  if (!str?.toString()) return false;
  // Regular expression to detect HTML tags
  const htmlRegex = /<[^>]+>/g;
  return htmlRegex.test(str);
};

export const convertDates = (obj) => {
  const newObj = { ...obj };
  Object.keys(obj).forEach((r) => {
    const possibleDate = moment(obj[r]?.length === 13 ? obj[r] * 1 : null);
    if (possibleDate.isValid()) {
      newObj[r] = possibleDate.format("MM-DD-YYYY");
    }
  });
  return newObj;
};

export const extractVariables = (str) => {
  if (!str) return [];
  // Use a regular expression to match all {{variableName}} patterns
  const regex = /{{(.*?)}}/g;
  let match;
  const variables = [];

  // Iterate over all matches in the string
  while ((match = regex.exec(str)) !== null) {
    variables.push(match[1]);
  }

  // make unique
  const uniqueSet = new Set(variables);
  const uniqueVars = [...uniqueSet].filter((v) => v !== "");

  return uniqueVars;
};

export const formatDuration = (sec) => {
  let seconds = parseInt(sec || 0) || 0;
  if (seconds <= 0) return "0 seconds";

  const units = [
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  const result = [];

  for (const unit of units) {
    const count = Math.floor(seconds / unit.seconds);
    if (count > 0) {
      result.push(`${count} ${unit.label}${count > 1 ? "s" : ""}`);
      seconds %= unit.seconds; // Update the remaining seconds
    }
  }

  return result.join(" ");
};

export const parseAndLimit = (value) => {
  // Parse the float
  const parsedValue = parseFloat(value || 0);

  // Check if the value is NaN
  if (isNaN(parsedValue)) {
    console.log("Invalid number");
  }

  // Limit to 2 decimal places
  return parsedValue.toFixed(2);
};

const noWeekends = function (date) {
  const isWeekend = [0, 6].includes(date.day()) ? true : false;
  if (isWeekend) {
    return date.subtract((date.day() + 2) % 7, "days");
  } else {
    return date;
  }
};

export const calculateStartDate = () => {
  const currentDate = dayjs();
  const dateObj = {
    middle: noWeekends(dayjs().utc().date(15)),
    last: noWeekends(dayjs().utc().endOf("month")),
    next: noWeekends(dayjs().utc().add(1, "month").date(15)),
  };

  if (currentDate.isBefore(dateObj.middle)) {
    return dateObj.middle;
  } else if (currentDate.isBefore(dateObj.last)) {
    return dateObj.last;
  } else {
    return dateObj.next;
  }
};
